// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3jQP-","buttons":"RemoveExpirationActionButtons_buttons__IG18U"};